import React, { useMemo } from 'react';

import Period from 'components/Period';

import { useScreenState } from '@gogame/screens';

import {
  FILTER_TITLES,
  FILTER_CREATIVE_CREATION_PERIOD,
  FILTER_CREATIVE_CONCEPT_CREATION_PERIOD,
} from 'scenes/Trackers/Tracker/constants';
import { useLoadFilterDetails } from 'scenes/Trackers/Tracker/data/useLoadFilterDetails';
import WidgetFilters from 'scenes/Trackers/components/Widget/WidgetFilters';

const getFilterTitle = (id) => FILTER_TITLES[id];

const TrackerPresetFilters = () => {
  const { filtersCollection } = useScreenState();

  const { data, isLoading } = useLoadFilterDetails({
    filters: filtersCollection,
  });

  const compareMode = filtersCollection?.length > 1;

  const dataWithPeriods = useMemo(
    () =>
      data?.map((collection, i) => {
        const {
          [FILTER_CREATIVE_CREATION_PERIOD]: createCreationPeriod,
          [FILTER_CREATIVE_CONCEPT_CREATION_PERIOD]:
            createConceptCreationPeriod,
        } = filtersCollection[i] || {};

        return {
          ...collection,
          ...(createCreationPeriod
            ? {
                [FILTER_CREATIVE_CREATION_PERIOD]: (
                  <Period value={createCreationPeriod} />
                ),
              }
            : null),
          ...(createConceptCreationPeriod
            ? {
                [FILTER_CREATIVE_CONCEPT_CREATION_PERIOD]: (
                  <Period value={createConceptCreationPeriod} />
                ),
              }
            : null),
        };
      }),
    [data, filtersCollection]
  );

  return (
    <WidgetFilters
      data={dataWithPeriods}
      isLoading={isLoading}
      compareMode={compareMode}
      getFilterTitle={getFilterTitle}
    />
  );
};

export default TrackerPresetFilters;
